export interface KWHConfig {
  getPersondatenFromAtruvia: boolean;
  archiving: Archiving;
  bestellphase: string;
  deprecatedBankCodes: any[];
  clientUrl: string;
  clientUrlTesting: string;
  fomEmail: string;
  bic: string;
  blz: string;
  isAidServiceActive: boolean;
  fax: string;
  courierEmail: string;
  templateSenderAddress: TemplateSenderAddress;
  noReplyAfterWarrantSentToTransferring: NoReplyAfterWarrantSentToTransferring;
  canActivate?: boolean;
  showArchivingSection: boolean;
  autoApplyStandingOrders: boolean;
}

export interface NoReplyAfterWarrantSentToTransferring {
  bankingDays: number;
}

export interface TemplateSenderAddress {
  department: null;
  faxNumber: null;
  phoneNumber: null;
  displayName: CustomOrIntba;
  address: CustomOrIntba;
  postcode: CustomOrIntba;
  city: CustomOrIntba;
}

export interface Archiving {
  docTypes: string[];
  flow: string;
}

export interface CustomOrIntba {
  customValue: null;
  intbaValue: string;
}

export const ARCHIVING_FLOW = {
  NONE: 'NONE',
  FINAL_STATE: 'FINAL_STATE',
};
